'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var React = require("react");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var PFTypes = require("@softwarefactory-project/re-patternfly/src/PFTypes.bs.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var RemoteAPI = require("@softwarefactory-project/res-remoteapi/src/RemoteAPI.bs.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Belt_Result = require("bs-platform/lib/js/belt_Result.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.bs.js");
var ReactCore = require("@patternfly/react-core");
var ReactIcons = require("@patternfly/react-icons");

function optionToResult(v, error) {
  if (v !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: Caml_option.valFromOption(v)
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: error
          };
  }
}

function makeDeccoError(message, value) {
  return {
          path: "",
          message: message,
          value: value
        };
}

var listToReactArray = Belt_List.toArray;

function result_t_encode(v) {
  return Js_dict.fromArray([
              [
                "result",
                Decco.stringToJson(v.result)
              ],
              [
                "waiver authorization",
                Decco.optionToJson(Decco.stringToJson, v.waiverAuthorization)
              ],
              [
                "message",
                Decco.optionToJson(Decco.stringToJson, v.message)
              ],
              [
                "details",
                Decco.optionToJson(Decco.stringToJson, v.details)
              ],
              [
                "remedy",
                Decco.optionToJson(Decco.stringToJson, v.remedy)
              ]
            ]);
}

function result_t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var result = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "result"), null));
  if (result.TAG === /* Ok */0) {
    var waiverAuthorization = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "waiver authorization"), null));
    if (waiverAuthorization.TAG === /* Ok */0) {
      var message = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
      if (message.TAG === /* Ok */0) {
        var details = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "details"), null));
        if (details.TAG === /* Ok */0) {
          var remedy = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "remedy"), null));
          if (remedy.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      result: result._0,
                      waiverAuthorization: waiverAuthorization._0,
                      message: message._0,
                      details: details._0,
                      remedy: remedy._0
                    }
                  };
          }
          var e = remedy._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".remedy" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = details._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".details" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = message._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".message" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = waiverAuthorization._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".waiver authorization" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = result._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".result" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function results_t_encode(v) {
  return Decco.listToJson(result_t_encode, v);
}

function results_t_decode(v) {
  return Decco.listFromJson(result_t_decode, v);
}

function decode(json) {
  return Belt_Result.flatMap(optionToResult(Js_json.decodeObject(json), {
                  path: "",
                  message: "Unable to decode report",
                  value: json
                }), (function (top) {
                return {
                        TAG: /* Ok */0,
                        _0: Belt_List.map(Belt_List.fromArray(Js_dict.entries(top)), (function (param) {
                                var name = param[0];
                                var r_results = param[1];
                                return Belt_Result.flatMap(Decco.listFromJson(result_t_decode, r_results), (function (results) {
                                              return {
                                                      TAG: /* Ok */0,
                                                      _0: {
                                                        name: name,
                                                        results: results
                                                      }
                                                    };
                                            }));
                              }))
                      };
              }));
}

function sanitize(report) {
  return Belt_List.keep(Belt_List.map(Belt_List.keep(Belt_List.map(report, (function (re) {
                            if (re.TAG !== /* Ok */0) {
                              return ;
                            }
                            var entry = re._0;
                            return {
                                    name: entry.name,
                                    results: Belt_List.keep(entry.results, (function (result) {
                                            return Belt_Option.isSome(result.message);
                                          }))
                                  };
                          })), Belt_Option.isSome), Belt_Option.getExn), (function (entry) {
                return Belt_List.length(entry.results) > 0;
              }));
}

function filterResultsByLevel(results, level) {
  return Belt_List.keep(results, (function (result) {
                return result.result === level;
              }));
}

function discardResultsByLevel(results, level) {
  return Belt_List.keep(results, (function (result) {
                return result.result !== level;
              }));
}

function getLevelStats(report) {
  var getStats = function (level) {
    return Belt_List.reduce(sanitize(report), 0, (function (acc, entry) {
                  return acc + Belt_List.length(filterResultsByLevel(entry.results, level)) | 0;
                }));
  };
  return {
          ok: getStats("OK"),
          info: getStats("INFO"),
          verify: getStats("VERIFY"),
          bad: getStats("BAD")
        };
}

function getCategories(report) {
  return Belt_List.map(sanitize(report), (function (entry) {
                return entry.name;
              }));
}

var JsonReport = {
  result_t_encode: result_t_encode,
  result_t_decode: result_t_decode,
  results_t_encode: results_t_encode,
  results_t_decode: results_t_decode,
  decode: decode,
  sanitize: sanitize,
  filterResultsByLevel: filterResultsByLevel,
  discardResultsByLevel: discardResultsByLevel,
  getLevelStats: getLevelStats,
  getCategories: getCategories
};

function details(result) {
  var details$1 = result.details;
  if (details$1 !== undefined) {
    return React.createElement("p", undefined, React.createElement("b", undefined, "Details: "), details$1);
  } else {
    return null;
  }
}

function remedy(result) {
  var remedy$1 = result.remedy;
  if (remedy$1 !== undefined) {
    return React.createElement("p", undefined, React.createElement("b", undefined, "Remedy: "), remedy$1);
  } else {
    return null;
  }
}

function message(result) {
  return Belt_Option.getExn(result.message);
}

function alertBody(result) {
  return React.createElement("ul", undefined, React.createElement("li", undefined, details(result)), React.createElement("li", undefined, remedy(result)));
}

function getTitle(message) {
  return React.createElement("p", undefined, Belt_Option.getWithDefault(message, "No message"));
}

function App$Result(Props) {
  var result = Props.result;
  var match = result.result;
  switch (match) {
    case "BAD" :
        return React.createElement(ReactCore.Alert, {
                    children: alertBody(result),
                    title: getTitle(result.message),
                    variant: "danger"
                  });
    case "INFO" :
        return React.createElement(ReactCore.Alert, {
                    children: alertBody(result),
                    title: getTitle(result.message),
                    variant: "info"
                  });
    case "OK" :
        return React.createElement(ReactCore.Alert, {
                    children: alertBody(result),
                    title: getTitle(result.message),
                    variant: "success"
                  });
    case "VERIFY" :
        return React.createElement(ReactCore.Alert, {
                    children: alertBody(result),
                    title: getTitle(result.message),
                    variant: "warning"
                  });
    default:
      return null;
  }
}

var Result = {
  details: details,
  remedy: remedy,
  message: message,
  alertBody: alertBody,
  getTitle: getTitle,
  make: App$Result
};

function App$ReportResults(Props) {
  var name = Props.name;
  var results = Props.results;
  return React.createElement(ReactCore.Card, {
              children: null,
              isCompact: true
            }, React.createElement(ReactCore.CardTitle, {
                  children: name
                }), Belt_List.toArray(Belt_List.mapWithIndex(results, (function (i, result) {
                        return React.createElement(App$Result, {
                                    result: result,
                                    key: name + String(i)
                                  });
                      }))), React.createElement(ReactCore.CardBody, {}));
}

var ReportResults = {
  make: App$ReportResults
};

function App$Report(Props) {
  var data = Props.data;
  var match = React.useState(function () {
        return false;
      });
  var setOkCB = match[1];
  var ok_cb_state = match[0];
  var match$1 = React.useState(function () {
        return true;
      });
  var setInfoCB = match$1[1];
  var info_cb_state = match$1[0];
  var match$2 = React.useState(function () {
        return true;
      });
  var setVerifyCB = match$2[1];
  var verify_cb_state = match$2[0];
  var match$3 = React.useState(function () {
        return true;
      });
  var setBadCB = match$3[1];
  var bad_cb_state = match$3[0];
  var levelsStats = getLevelStats(data);
  var data$1 = sanitize(data);
  var displayRPMInspectInfo = function (entryname, displayname) {
    var command = Belt_Option.flatMap(Belt_List.head(Belt_List.keep(data$1, (function (entry) {
                    return entry.name === "rpminspect";
                  }))), (function (entry) {
            return Belt_Option.flatMap(Belt_List.head(Belt_List.keep(entry.results, (function (result) {
                                  return Belt_Option.getExn(result.message) === entryname;
                                }))), (function (result) {
                          return result.details;
                        }));
          }));
    if (command !== undefined) {
      return React.createElement(ReactCore.Card, {
                  children: null,
                  isCompact: true
                }, React.createElement(ReactCore.CardTitle, {
                      children: displayname
                    }), React.createElement(ReactCore.CardBody, {
                      children: command
                    }));
    } else {
      return null;
    }
  };
  var filterByFilters = function (results) {
    var filtered = [];
    return Belt_List.concat(Belt_List.concat(Belt_List.concat(Belt_List.concat(Belt_List.fromArray(filtered), ok_cb_state ? filterResultsByLevel(results, "OK") : /* [] */0), info_cb_state ? filterResultsByLevel(results, "INFO") : /* [] */0), verify_cb_state ? filterResultsByLevel(results, "VERIFY") : /* [] */0), bad_cb_state ? filterResultsByLevel(results, "BAD") : /* [] */0);
  };
  var getLabel = function (level) {
    var count = function (level) {
      switch (level) {
        case "BAD" :
            return levelsStats.bad;
        case "INFO" :
            return levelsStats.info;
        case "OK" :
            return levelsStats.ok;
        case "VERIFY" :
            return levelsStats.verify;
        default:
          return 0;
      }
    };
    return level + "(" + String(count(level)) + ")";
  };
  var displayFilter = React.createElement(ReactCore.Card, {
        children: null,
        isCompact: true
      }, React.createElement(ReactCore.CardTitle, {
            children: "Filters"
          }), React.createElement(ReactCore.CardBody, {
            children: React.createElement(ReactCore.Bullseye, {
                  children: React.createElement(ReactCore.Form, {
                        children: React.createElement(ReactCore.FormGroup, {
                              children: null,
                              fieldId: "filters",
                              isInline: true
                            }, React.createElement(ReactCore.Checkbox, {
                                  id: "BAD",
                                  isChecked: bad_cb_state,
                                  label: getLabel("BAD"),
                                  onChange: (function (param, param$1) {
                                      return Curry._1(setBadCB, (function (param) {
                                                    return !bad_cb_state;
                                                  }));
                                    })
                                }), React.createElement(ReactCore.Checkbox, {
                                  id: "VERIFY",
                                  isChecked: verify_cb_state,
                                  label: getLabel("VERIFY"),
                                  onChange: (function (param, param$1) {
                                      return Curry._1(setVerifyCB, (function (param) {
                                                    return !verify_cb_state;
                                                  }));
                                    })
                                }), React.createElement(ReactCore.Checkbox, {
                                  id: "INFO",
                                  isChecked: info_cb_state,
                                  label: getLabel("INFO"),
                                  onChange: (function (param, param$1) {
                                      return Curry._1(setInfoCB, (function (param) {
                                                    return !info_cb_state;
                                                  }));
                                    })
                                }), React.createElement(ReactCore.Checkbox, {
                                  id: "OK",
                                  isChecked: ok_cb_state,
                                  label: getLabel("OK"),
                                  onChange: (function (param, param$1) {
                                      return Curry._1(setOkCB, (function (param) {
                                                    return !ok_cb_state;
                                                  }));
                                    })
                                })),
                        isHorizontal: true
                      })
                })
          }));
  return React.createElement(ReactCore.Stack, {
              children: null,
              hasGutter: true
            }, displayRPMInspectInfo("command line", "RPMInspect command"), displayRPMInspectInfo("version", "RPMInspect version"), displayFilter, Belt_List.toArray(Belt_List.map(Belt_List.keep(data$1, (function (entry) {
                            return entry.name !== "rpminspect";
                          })), (function (entry) {
                        var results = filterByFilters(entry.results);
                        if (Belt_List.length(results) > 0) {
                          return React.createElement(App$ReportResults, {
                                      name: entry.name,
                                      results: results,
                                      key: entry.name
                                    });
                        } else {
                          return null;
                        }
                      }))));
}

var Report = {
  make: App$Report
};

function App$UserInput(Props) {
  var url = Props.url;
  var state = Props.state;
  var match = React.useState(function () {
        return url;
      });
  var setURL = match[1];
  var url$1 = match[0];
  var tmp;
  tmp = typeof state === "number" || state.TAG !== /* Loading */0 ? null : React.createElement(ReactCore.Spinner, {
          size: "lg"
        });
  return React.createElement(ReactCore.Card, {
              children: null,
              isCompact: true
            }, React.createElement(ReactCore.CardTitle, {
                  children: "RPMInspect report URL"
                }), React.createElement(ReactCore.CardBody, {
                  children: React.createElement(ReactCore.Grid, {
                        children: null,
                        hasGutter: true
                      }, React.createElement(ReactCore.GridItem, {
                            children: React.createElement(ReactCore.TextInput, {
                                  id: "RPMInspect report URL",
                                  onChange: (function (v, param) {
                                      return Curry._1(setURL, (function (param) {
                                                    return v;
                                                  }));
                                    }),
                                  type: "text",
                                  value: url$1
                                }),
                            span: PFTypes.Column._11
                          }), React.createElement(ReactCore.GridItem, {
                            children: null,
                            span: PFTypes.Column._1
                          }, React.createElement(ReactCore.Grid, {
                                children: React.createElement(ReactCore.GridItem, {
                                      children: React.createElement(ReactCore.Button, {
                                            children: "get",
                                            onClick: (function (param) {
                                                if (url$1.length !== 0) {
                                                  return RescriptReactRouter.push("?url=" + url$1);
                                                }
                                                
                                              }),
                                            variant: "secondary"
                                          }),
                                      span: PFTypes.Column._4
                                    }),
                                hasGutter: true
                              }), React.createElement(ReactCore.GridItem, {
                                children: tmp,
                                span: PFTypes.Column._3
                              })))
                }));
}

var UserInput = {
  make: App$UserInput
};

function Reporter(Client) {
  var Hook = RemoteAPI.Hook(Client);
  var header = React.createElement(ReactCore.PageHeader, {
        headerTools: React.createElement(ReactCore.PageHeaderTools, {
              children: React.createElement(ReactCore.PageHeaderToolsItem, {
                    children: React.createElement(ReactCore.Button, {
                          children: React.createElement("a", {
                                href: "https://github.com/rpminspect/rpminspect"
                              }, React.createElement(ReactIcons.HelpIcon, {})),
                          variant: "plain"
                        })
                  })
            }),
        logo: "RPMInspect"
      });
  var App$Reporter = function (Props) {
    var url = Props.url;
    var state = Curry._2(Hook.useAutoGet, url, decode);
    var tmp;
    if (typeof state === "number") {
      tmp = null;
    } else {
      switch (state.TAG | 0) {
        case /* Loading */0 :
            tmp = null;
            break;
        case /* Failure */1 :
            tmp = React.createElement(ReactCore.Alert, {
                  title: "Unable to load the report: " + state._0,
                  variant: "danger"
                });
            break;
        case /* Success */2 :
            tmp = React.createElement(App$Report, {
                  data: state._0
                });
            break;
        
      }
    }
    return React.createElement(ReactCore.Page, {
                children: null,
                header: header
              }, React.createElement(ReactCore.PageSection, {
                    children: React.createElement(App$UserInput, {
                          url: url,
                          state: state
                        }),
                    variant: "dark"
                  }), React.createElement(ReactCore.PageSection, {
                    children: tmp,
                    variant: "default"
                  }));
  };
  return {
          Hook: Hook,
          header: header,
          make: App$Reporter
        };
}

function Main(Client) {
  var Hook = RemoteAPI.Hook(Client);
  var header = React.createElement(ReactCore.PageHeader, {
        headerTools: React.createElement(ReactCore.PageHeaderTools, {
              children: React.createElement(ReactCore.PageHeaderToolsItem, {
                    children: React.createElement(ReactCore.Button, {
                          children: React.createElement("a", {
                                href: "https://github.com/rpminspect/rpminspect"
                              }, React.createElement(ReactIcons.HelpIcon, {})),
                          variant: "plain"
                        })
                  })
            }),
        logo: "RPMInspect"
      });
  var App$Reporter = function (Props) {
    var url = Props.url;
    var state = Curry._2(Hook.useAutoGet, url, decode);
    var tmp;
    if (typeof state === "number") {
      tmp = null;
    } else {
      switch (state.TAG | 0) {
        case /* Loading */0 :
            tmp = null;
            break;
        case /* Failure */1 :
            tmp = React.createElement(ReactCore.Alert, {
                  title: "Unable to load the report: " + state._0,
                  variant: "danger"
                });
            break;
        case /* Success */2 :
            tmp = React.createElement(App$Report, {
                  data: state._0
                });
            break;
        
      }
    }
    return React.createElement(ReactCore.Page, {
                children: null,
                header: header
              }, React.createElement(ReactCore.PageSection, {
                    children: React.createElement(App$UserInput, {
                          url: url,
                          state: state
                        }),
                    variant: "dark"
                  }), React.createElement(ReactCore.PageSection, {
                    children: tmp,
                    variant: "default"
                  }));
  };
  var Reporter$prime = {
    Hook: Hook,
    header: header,
    make: App$Reporter
  };
  var App$Main = function (Props) {
    var qs = RescriptReactRouter.useUrl(undefined, undefined).search;
    var url = new URLSearchParams(qs).get("url");
    if (url == null) {
      return React.createElement(App$Reporter, {
                  url: ""
                });
    } else {
      return React.createElement(App$Reporter, {
                  url: url
                });
    }
  };
  return {
          Reporter$prime: Reporter$prime,
          make: App$Main
        };
}

var RemoteData;

exports.RemoteData = RemoteData;
exports.optionToResult = optionToResult;
exports.makeDeccoError = makeDeccoError;
exports.listToReactArray = listToReactArray;
exports.JsonReport = JsonReport;
exports.Result = Result;
exports.ReportResults = ReportResults;
exports.Report = Report;
exports.UserInput = UserInput;
exports.Reporter = Reporter;
exports.Main = Main;
/* react Not a pure module */
